/* eslint-disable no-unused-expressions */
<template>
  <span id="mySpan">
    <div
      v-if="boardIsClosed"
      id="clickBlocker"
    ></div>
    <div
      v-show="menu.rightClicked"
      id="drawingMenu"
    >
      <div
        class="drawingMenuBlock"
        id="drawingOptions"
      >
        <div
          @click="drawingOnOffClick()"
          :class="menu.drawing?'active':'notActive'"
          id="drawingOnOff"
        >
          <b-icon
            icon="pencil-alt"
            pack="fas"
          ></b-icon>
        </div>
        <div
          @click="selectingOnOffClick()"
          :class="menu.selecting?'active':'notActive'"
          id="selectingOnOff"
        >
          <b-icon
            icon="object-group"
            pack="far"
          ></b-icon>
        </div>

        <div
          class=" leftMenuBtn"
          id="selectingOnOff"
          :class="{active : menu.linkHier}"
          @click="linkWithHierarchy()"
        >
          <b-icon
            icon="long-arrow-alt-right"
            pack="fas"
            class="leftIcon myIcons"
            custom-size="null"
            custom-class="innerIcons"
          ></b-icon>
        </div>
        <div
          class=" leftMenuBtn"
          id="selectingOnOff"
          :class="{active : menu.linkSimple}"
          @click="linkWithoutHierarchy()"
        >
          <b-icon
            icon="window-minimize"
            pack="fas"
            class="leftIcon myIcons"
            custom-size="null"
            custom-class="innerIcons"
          ></b-icon>
        </div>

        <div
          @click="erasingOnOffClick()"
          :class="menu.erasing?'active':'notActive'"
          id="erasingOnOff"
        >
          <b-icon
            icon="eraser"
            pack="fas"
          ></b-icon>
        </div>
        <div
          @click="writingOnOffClick()"
          :class="menu.modeWriting?'active':'notActive'"
          id="writingOnOff"
        >
          <b-icon
            icon="font"
            pack="fa"
          ></b-icon>
        </div>
      </div>
      <div
        class="drawingMenuBlock"
        id="drawingWidth"
      >
        <input
          class="slider is-fullwidth"
          step="1"
          min="3"
          max="50"
          v-model="width"
          type="range"
        />
        <p style="width: 35px; margin: 5px;">{{width}}px</p>
      </div>
      <div
        class="drawingMenuBlock"
        id="drawingColors"
      >
        <div
          v-for="(color, key) in colors"
          :key="key"
          :style="color === lineColor? 'border:2px solid black; box-sizing: border-box;margin:0px;':'border:none;margin: 1px;'"
        >
          <div
            class="colorBlock"
            :style="`background-color:${color};`"
            @click="changeColor(color)"
          ></div>
        </div>
      </div>
    </div>

    <div
      id="textWriting"
      v-show="menu.textWriting && menu.modeWriting"
    >
      <textarea
        :placeholder="$t('svg.placeholder')"
        type="text"
        id="textContent"
        @keypress.enter="validateText"
      />
    </div>
    <svg
      ref="svgBoard"
      :class="menu.erasing?'eraseCursor':menu.drawing ?'drawCursor':menu.modeWriting?'writingCursor':'defaultCursor'"
      xmlns="http://www.w3.org/2000/svg"
      width="3840px"
      height="2160px"
      @dblclick.self.prevent.exact="doubleClickBoard"
      id="svgBoard"
      @click.left.ctrl.self="selectedPosts= [];selectedSvgs = []"
      @mousedown.left="linestart(); selecting = true"
      @mousemove.left="lineMove()"
      @mousemove="mouseCapture"
      @mouseup="selecting = false"
      v-touch:moving.passive="(e)=>{lineMove(e); selecting = true}"
      v-touch:end.left.passive="(e)=>{lineEnd(e)}"
      @onmouseleave.left="lineEnd()"
      @touchcancel="lineEnd()"
      @click.right.exact.prevent="openMenu()"
      v-touch:longtap.self.passive="()=>{openMenu()}"
      @click.left.exact.self="clickHandler"
    >
      <!-- Defs are hidden components usable by other shapes, eg: the head of arrows -->
      <defs>
        <!-- "head" of the arrows -->
        <marker
          v-for="(color, key) in colors"
          :key="key"
          :id="`triangle${key}`"
          refX="1"
          refY="2.5"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
        >
          <path
            d="M 0 0 L 5 2.5 L 0 5 z"
            :style="`fill:${color};`"
          />
        </marker>
        <marker
          v-for="(color, key) in colors"
          :key="'line'+key"
          :id="`line${key}`"
          refX="1"
          refY="0.55"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
        >
          <path
            d="M 0 0 L 5 0 "
            :style="`stroke:${color};stroke-width:2`"
          />
        </marker>
        <!-- end of "head" of the arrows -->
        <marker
          id="dot"
          viewBox="0 0 10 10"
          refX="5"
          refY="5"
          markerWidth="5"
          markerHeight="5"
        >
          <circle
            cx="5"
            cy="5"
            r="5"
            fill="red"
          />
        </marker>
      </defs>
      <template v-if="isChoosingPlace">
        <rect
          x="0"
          y="0"
          width="3840px"
          height="2160px"
          style="fill:black;stroke-width:0;fill-opacity:0.7;"
        />
      </template>

      <post
        @click.ctrl.prevent.self="selectOnePost(post.id)"
        class="post"
        v-for="post in freePosts"
        :key="'post'+post.id"
        ref="post"
        :hasFilteredColor="hasFilteredColor"
        :post="post"
        :selected="selectedPosts.includes(post.id)"
        @moving="moveGroup"
        @stopped="commit"
      />
      <!-- Shows links that are not being edited -->
      <Links
        ref="link"
        v-for="(link, key) in links"
        :key="key"
        :link="link"
        v-if="link.id !== editingLink"
      />
      <!-- Shows link that is being edited, so it is above the others -->
      <Links
        ref="link"
        v-for="(link, key) in links"
        :key="key"
        :link="link"
        v-if="link.id === editingLink"
      />
      <!-- Those rectangles are the blue/grey selection box the user creates with the select tool -->
      <rect
        fill="none"
        stroke="#ffffff"
        v-show="this.menu.selecting && selecting"
        :x="selectBoxBeginningX()"
        :y="selectBoxBeginningY()"
        :width="selectBoxEndX()"
        :height="selectBoxEndY()"
        id="whiteStroke"
      />
      <rect
        fill="#3535c759"
        stroke="#1d1dc8"
        stroke-dasharray="4"
        v-show="this.menu.selecting && selecting"
        :x="selectBoxBeginningX()"
        :y="selectBoxBeginningY()"
        :width="selectBoxEndX()"
        :height="selectBoxEndY()"
        id="selectBox"
      />
      <!-- End of Those rectangles are the blue/grey selection box the user creates with the select tool -->

      <TextSvg
        v-for="text in texts"
        :key="text.id+'text'"
        ref="text"
        :textObj="text"
        :text="text.attributes.text"
        @stopEditingText="disabledChildrenTextsEditing"
        @click="clickHandler"
        :hasFilteredColor="hasFilteredColor"
        v-show="text.sheet || text.sheet_id=== currentSheet"
      />
      <Dessin
        v-for="(singleSvg,key) in drawnSVG"
        :key="singleSvg.id+'singleSvg'"
        :singleSvgObj="singleSvg"
        ref="dessin"
        @click="clickHandler"
        :hasFilteredColor="hasFilteredColor"
        v-show="singleSvg.sheet || singleSvg.sheet_id=== currentSheet"
      />
      <!-- those rectangles are the grey/white box around selections -->
      <rect
        v-if="this.postlist.length > 0 && selectedPosts.length > 0 && this.$refs.post"
        id="selectContBorder"
        stroke="#ffffffaa"
        stroke-dasharray="8 10"
        stroke-dashoffset="9"
        fill="none"
        :x="xSelectCont()"
        :y="ySelectCont()"
        :width="widthSelectCont()"
        :height="heightSelectCont()"
      />
      <rect
        v-if="this.postlist.length > 0 && selectedPosts.length > 0 && this.$refs.post"
        id="selectCont"
        stroke="#000000aa"
        stroke-dasharray="8 10"
        fill="none"
        :x="xSelectCont()"
        :y="ySelectCont()"
        :width="widthSelectCont()"
        :height="heightSelectCont()"
      />
      <!-- End of those rectangles are the grey/white box around selections -->
      <!-- this g is the small box sitting on top of the selected post box, and contains icon calling different actions-->
      <g
        v-if="this.postlist.length > 0 && selectedPosts.length > 0 && this.$refs.post"
        fill="#424a60"
        stroke="#ffffff"
        stroke-width="1.5"
        :transform="`translate(${xSelectCont() - 60}, ${ySelectCont()-25 > 0 ? ySelectCont()-75:ySelectCont() +heightSelectCont() -50})`"
      >
        <rect
          x="60"
          y="50"
          width="105"
          height="25"
          fill="#424a60"
          stroke="#ffffff"
          stroke-width="1.5"
          id="selectMenuBack"
        />
      </g>

    </svg>

    <div
      id="selectMenu"
      v-if="xSelectCont() < 3840 && ySelectCont() < 2160"
      :style="`left: ${xSelectCont() }px;top: ${ySelectCont()-25 > 0 ? ySelectCont()-25:ySelectCont() +heightSelectCont() }px;`"
    >

      <span
        @click.exact="selectedPosts= [];selectedSvgs = []"
        v-touch="()=>{selectedPosts= [];selectedSvgs = []}"
      >
        <b-tooltip
          type="is-primary"
          :label="$t('tooltip.cancelSelect')"
          position="is-top"
          size="is-small"
        >
          <b-icon
            class="editbutton"
            pack="fas"
            icon="times"
            size="is-small"
          ></b-icon>
        </b-tooltip>
      </span>

      <span
        class="folderize"
        @click="createFolder"
      >
        <b-tooltip
          type="is-primary"
          :label="$t('tooltip.folderize')"
          position="is-top"
          size="is-small"
        >
          <i class="fas fa-folder-open"></i>
        </b-tooltip>
      </span>
      <span
        @click.exact="order"
        v-touch="order"
      >
        <b-tooltip
          type="is-primary"
          :label="$t('tooltip.order')"
          position="is-top"
          size="is-small"
        >
          <b-icon
            class="editbutton"
            pack="fas"
            icon="sort-amount-up"
            size="is-small"
          ></b-icon>
        </b-tooltip>
      </span>

      <span
        @click.exact="openEditPopup"
        v-touch="openEditPopup"
      >
        <b-tooltip
          type="is-primary"
          :label="$t('tooltip.groupedSettings')"
          position="is-top"
          size="is-small"
        >
          <b-icon
            class="editbutton"
            pack="fas"
            icon="cog"
            size="is-small"
          ></b-icon>
        </b-tooltip>
      </span>

      <span
        @click.exact="deleteGroup"
        v-touch="deleteGroup"
      >
        <b-tooltip
          type="is-primary"
          :label="$t('tooltip.groupDelete')"
          position="is-top"
          size="is-small"
        >
          <b-icon
            class="editbutton"
            pack="fas"
            icon="trash-alt"
            size="is-small"
          ></b-icon>
        </b-tooltip>
      </span>
    </div>
    <Folders
      v-for="(folder, key) in this.displayedFolders"
      :key="key"
      :folder="folder"
    />

    <div
      id="cursor"
      v-bind:style="{ 'background-color': lineColor }"
    ></div>
    <b-modal
      :active.sync="groupEditActive"
      @close="colorNum = null"
    >
      <div
        id="bodyModalCont"
        style="overflow-y: auto;max-height: 90vh;overflow-x: auto;"
      >
        <h2>{{$tc('group.edit',selectedPosts.length,{nbPostit:selectedPosts.length} )}}</h2>
        <b-table
          :data="refToSelectedPosts()"
          style="overflow-x: auto;max-height: 50vh;"
        >
          <b-table-column
            field="couleur"
            :label="$t('group.couleur')"
            width="10"
          >
            <template v-slot:default="props">

              <div
                :style="`background-color:${colorNum == null ?props.row.couleur: colors[colorNum] };`"
                class="colorCircle"
              ></div>
            </template>

          </b-table-column>
          <b-table-column
            field="contenu"
            :label="$t('group.contenu')"
            width="40"
          >
            <template v-slot:default="props">

              {{ props.row.contenu }}
            </template>
          </b-table-column>
        </b-table>
        <p id="colorSelect">{{$t('group.editColor')}}</p>
        <div id="groupEditColorCont">
          <div
            v-for="(color, key ) in colors"
            :style="`background-color: ${color};`"
            @click="colorNum === key ? colorNum =null :colorNum = key"
            class="colorPicker"
            :class="colorNum === key ? 'selected':''"
            :key="key"
            v-if=" key< colors.length - 2"
          ></div>
        </div>
        <p id="sheetSelect">{{$t('group.editSheet')}}</p>
        <b-select
          icon="book-open"
          id="groupEditSheet"
          :value="this.currentSheet"
        >
          <option
            v-for="sheet in this.current.sheets"
            :key="sheet.id"
            :value="sheet.id"
          >
            {{sheet.name}}
          </option>
        </b-select>
        <button
          class="button"
          id="popupCancel"
          @click="groupEditActive = false"
        > {{$t('dialog.cancel')}}</button>
        <button
          class="button is-success"
          id="popupConfirm"
          @click="sendGroupEdit"
        > {{$t('dialog.confirm')}}</button>
      </div>
    </b-modal>
    <b-modal :active.sync="editPostLinkActive">
      <editLinksPopup :id="idPostLinkEdit" />
    </b-modal>

  </span>
</template>

<script>
import EditLinksPopup from './modal/EditLinksPopup'

import TextSvg from './TextSvg'
import Dessin from './DessinSvg'
import Links from './Links'
import Folders from './Folders'
import post from '../post/post'
import EventBus from '../../EventBus'
import debounce from 'lodash.debounce'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
const $ = document.querySelector.bind(document)
const $$ = document.querySelectorAll.bind(document)
export default {
  name: 'board',
  components: {
    TextSvg,
    Dessin,
    Folders,
    Links,
    post,
    EditLinksPopup

  },
  data () {
    return {
      editingLink: null,
      editPostLinkActive: false,
      idPostLinkEdit: -1,
      texts: [],
      drawnSVG: [],
      links: [],
      groupEditActive: false,
      debounced: debounce((e) => { this.lineEnd(e) }, 500),
      lockDebouncing: debounce((e) => { this.linestart(e) }, 500, { 'leading': true }),
      selectBox: {
        pressStartPoint: { x: 0, y: 0 },
        pressStopPoint: { x: 0, y: 0 }
      },
      selectedPosts: [],
      selectedSvgs: [],
      selecting: false,
      board: '',
      mouseX: 0,
      mouseY: 0,
      cursor: '',
      colorNum: null,
      gesture: false,
      line: '',
      radius: 2.5,
      width: 8,
      undo: false,
      onCanvas: false, // mouseout event is not firing, dunno why
      title: '',
      colors: [],
      bgColors: [],
      lineColor: 'rgb(20,20,20)',
      bgColor: 'none'
    }
  },
  props: {
    hasFilteredColor: String
  },
  computed: {
    freePosts () {
      let posts = this.postlist
      if (posts.length > 0) {
        posts = posts.filter(post => {
          return (post.folder_id === undefined || post.folder_id === null)
        })
      }
      return posts
    },
    displayedFolders () {
      let folders = [...this.folders]

      return folders.filter(folder => folder.sheet_id === this.currentSheet)
    },

    ...mapState({
      postlist: 'currentBoardPost',
      current: 'current',
      currentSheet: 'currentSheet',
      isChoosingPlace: 'isChoosingPlace',
      menu: 'menu',
      folders: 'folders',
      isLoading: 'isLoading',
      linking: 'linking',
      boardIsClosed: "boardIsClosed"
    })

  },
  watch: {
    currentSheet: {
      handler (val) {
        this.background(val)
        this.selectedPosts = []
      }
    },
    current: {
      handler (val) {
        // console.log(val)

        this.colors = JSON.parse(this.current.colours)
        while (typeof this.colors !== 'object') {
          this.colors = JSON.parse(this.colors)
        }
        this.colors.push('rgb(255,255,255)', 'rgb(20,20,20)')

        // this.setActiveColorMounted('.lineColor li', this.colors, this.lineColor)
        // this.setActiveColorMounted('.bgColor li', this.bgColors, this.bgColor)
      }
    },
    isLoading: {
      handler () {
        this.background(this.currentSheet)
      }
    }

  },
  created () {
    EventBus.$on('UPLOAD_SHEET', idSheet => {
      this.background(idSheet)
    })
  },
  methods: {
    createFolder () {
      fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder`, {
        headers: {

          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
        },
        method: 'POST',
        body: JSON.stringify({
          board_id: this.current.id,
          posts_id: this.selectedPosts
        })
      }).then(res => { this.selectedPosts = [] })
    },
    resetColor () {
      setTimeout(() => { this.colorNum = null }, 200)
    },
    getEditingLink () {
      let editingLink = null
      if (this.$refs && this.$refs.link) {
        editingLink = this.$refs.link.filter(link => {
          return link.editing === true
        })[0]
        editingLink ? editingLink = editingLink.link.id : editingLink = null
      }
      this.editingLink = editingLink
    },
    getHeightOffset () {
      return this.$refs.svgBoard ? this.$refs.svgBoard.getBoundingClientRect().y : 0
    },
    getWidthOffset () {
      return this.$refs.svgBoard ? this.$refs.svgBoard.getBoundingClientRect().x : 0
    },
    mouseCapture (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY
    },
    postToLinkX () { // function to get the X of the post's connector
      if (this.linking.currentChild !== null && this.$refs.post) {
        let post = this.$refs.post.filter(post => { return post.id === this.linking.currentChild })[0]
        return post.clientX
      } else if (this.linking.currentParent !== null && this.$refs.post) {
        let post = this.$refs.post.filter(post => { return post.id === this.linking.currentParent })[0]
        return post.clientX
      } else { return 0 }
    },
    postToLinkY () { // function to get the Y of the post's connector
      if (this.linking.currentChild !== null && this.$refs.post) {
        let post = this.$refs.post.filter(post => { return post.id === this.linking.currentChild })[0]
        return post.clientY
      } else if (this.linking.currentParent !== null && this.$refs.post) {
        let post = this.$refs.post.filter(post => { return post.id === this.linking.currentParent })[0]
        return post.clientY
      } else { return 0 }
    },
    selectOnePost (id) {
      if (this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer') {
        this.selectedPosts.push(id)
      }
    },
    // calls the function of texts, turning off their editing
    disabledChildrenTextsEditing (id) {
      this.$refs.text.forEach(text => {
        text.disableEditing(id)
      })
    },
    // function called on "confirm" from the multi edit popup. gather the changes and 'commits' them to the back-end
    sendGroupEdit () {
      let posts = this.refToSelectedPosts() // gather all the selected posts
      posts.forEach(post => {
        if (this.colorNum !== null) {
          post.couleur = this.colors[this.colorNum] // change their colors
        }

        post.sheet_id = parseInt(document.querySelector('#groupEditSheet').value) // change their sheet
      })
      this.commit() // send the changes
      this.groupEditActive = false // turn off multi-editing
      this.colorNum = null
      if (posts[0].sheet_id !== this.currentSheet) {
        this.selectedPosts = [] // empty the selection list if they changed sheet
      }
    },
    refToSelectedPosts () {
      if (this.$refs.post) {
        let selectedPosts = this.$refs.post.filter(post => { return this.selectedPosts.includes(post.id) })
        // console.log(selectedPosts)

        return selectedPosts
      }
    },
    // function called to reposition selected posts into a neat square
    order () {
      let postsToOrder = this.$refs.post.filter(post => { return this.selectedPosts.includes(post.id) }) // get the posts
      let x = parseInt(document.querySelector('#selectCont').attributes.x.value) // get the most left point
      let y = parseInt(document.querySelector('#selectCont').attributes.y.value) // get the highest point
      let constY = parseInt(document.querySelector('#selectCont').attributes.y.value) // create a backup of y
      let height = parseInt(document.querySelector('#selectCont').attributes.height.value) // get the max height to order posts in
      postsToOrder.sort((a, b) => { // order posts by color
        let colA = a.couleur.toUpperCase()
        let colB = b.couleur.toUpperCase()
        if (colA < colB) {
          return -1
        }
        if (colA > colB) {
          return 1
        }
        return 0
      })

      postsToOrder.forEach(post => { // actually move the posts
        post.x = x // starts at the beginning of the square
        post.y = y // starts at the beginning of the square

        y += 45 + post.height // increments the y so posts don't overlap
        if (y > constY + height) { // if we exceed the height, go back to the top and move right
          x += 295
          y = constY
        }
      })
      this.commit() // send the changes to the backend
    },
    openEditPopup () {
      this.groupEditActive = true
    },
    deleteGroup () {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('dialog.cancel'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('confirm.deleteGroup', { nbPostits: this.selectedPosts.length }),
        onConfirm: () => {
          let toDelete = this.$refs.post.filter(post => { return this.selectedPosts.includes(post.id) }) // get all selected posts
          toDelete.forEach(post => {
            post.deletepostFromParent() // call the delet from the child component
          })
          this.selectedPosts = [] // empty the selection
          this.$buefy.toast.open({
            message: this.$i18n.t('posts.supprimer.notification'),
            type: 'is-success',
            position: 'is-bottom'
          })
        }
      })
    },
    xSelectCont () { // get the most left post in the selected posts array
      if (this.$refs.post !== undefined && this.$refs.post !== null) {
        let minX = 7000000000
        this.selectedPosts.forEach(postId => {
          let post = this.$refs.post.filter(post => {
            return post.id === postId
          })
          if (post[0] && post[0].x < minX) {
            minX = post[0].x
          }
        })

        return minX - 2
      } else { return 7000000 }
    },
    ySelectCont () { // get the highest post in the selected posts array
      let minY = 7000000000
      this.selectedPosts.forEach(postId => {
        let post = this.$refs.post.filter(post => { return post.id === postId })[0]
        if (post && post.y && post.y < minY) {
          minY = post.y
        }
      })
      return minY - 2
    },
    widthSelectCont () { // calculate the width of the select Box by taking the most right posts and adding its width
      let maxX = 0
      this.selectedPosts.forEach(postId => {
        let post = this.$refs.post.filter(post => { return post.id === postId })[0]
        if (post && post.x && post.x + post.width > maxX) {
          maxX = post.x + post.width
        }
      })
      return maxX - this.xSelectCont() + 4
    },
    heightSelectCont () { // calculate the height of the select Box by taking the lowest posts and adding its height
      let maxY = 0
      this.selectedPosts.forEach(postId => {
        let post = this.$refs.post.filter(post => { return post.id === postId })[0]
        if (post && post.y && post.y + post.height > maxY) {
          maxY = post.y + post.height
        }
      })
      return maxY - this.ySelectCont() + 4
    },
    commit () { // sends the modified posts to the back end to store in DB and hydrate other clients through node
      let modifiedPosts = this.$refs.post.filter(post => { return this.selectedPosts.includes(post.id) }) // get all selected posts
      let data = []
      modifiedPosts.forEach((post) => {
        let postDataToKeep = {}
        postDataToKeep.board_id = this.current.id
        postDataToKeep.id = post.id
        if (post.x !== null && post.contenu !== undefined) { postDataToKeep.contenu = post.contenu }
        if (post.x !== null && post.x !== undefined) { postDataToKeep.x = post.x }
        if (post.y !== null && post.y !== undefined) { postDataToKeep.y = post.y }
        if (post.couleur !== null && post.couleur !== undefined) { postDataToKeep.couleur = post.couleur }
        if (post.sheet_id !== null && post.sheet_id !== undefined) { postDataToKeep.sheet_id = post.sheet_id }
        if (post.etat !== null && post.etat !== undefined) { postDataToKeep.etat = post.etat }
        if (post.like !== null && post.like !== undefined) { postDataToKeep.like = post.like }
        if (post.link !== null && post.link !== undefined) { postDataToKeep.link = post.link }
        if (post.media !== null && post.media !== undefined) { postDataToKeep.media = post.media }

        data.push(postDataToKeep) // save all modifications
      })

      fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/post`, { // sends them
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(data)
      })
    },
    moveGroup (data) { // function to move posts when in selection
      // This functions is sent from the post component that is clicked/touched, and will hydrate all other posts in the selection
      this.selectedPosts.forEach(post => {
        if (post !== data.id && !isNaN(data.movedX) && !isNaN(data.movedY)) { // check we are not trying to move again the original post
          for (let i = 0; i < this.$refs.post.length; i++) {
            if (this.$refs.post[i].id === post) { // check all post components and activate their functions if they are selected and not the original moving post
              this.$refs.post[i].movedFromParent(data.movedX, data.movedY)
            }
          }
        }
      })
    },

    // following functions are all tests for the select box the user can create with the tool, to handle drags from left to right, right to left, ect
    selectBoxBeginningX () {
      if (this.selectBox.pressStartPoint.x < this.selectBox.pressStopPoint.x) {
        return this.selectBox.pressStartPoint.x
      } else {
        return this.selectBox.pressStopPoint.x
      }
    },
    selectBoxBeginningY () {
      if (this.selectBox.pressStartPoint.y < this.selectBox.pressStopPoint.y) {
        return this.selectBox.pressStartPoint.y
      } else {
        return this.selectBox.pressStopPoint.y
      }
    },
    selectBoxEndX () {
      if (this.selectBox.pressStartPoint.x < this.selectBox.pressStopPoint.x) {
        return this.selectBox.pressStopPoint.x - this.selectBox.pressStartPoint.x
      } else {
        return this.selectBox.pressStartPoint.x - this.selectBox.pressStopPoint.x
      }
    },
    selectBoxEndY () {
      if (this.selectBox.pressStartPoint.y < this.selectBox.pressStopPoint.y) {
        return this.selectBox.pressStopPoint.y - this.selectBox.pressStartPoint.y
      } else {
        return this.selectBox.pressStartPoint.y - this.selectBox.pressStopPoint.y
      }
    },
    background (idSheet) {
      // permet de savoir quelle feuille est en cours
      let sheet_en_cours = this.current.sheets.filter(
        feuille => feuille.id === idSheet
      )
      // bg de la board
      if (this.current.template !== null && sheet_en_cours[0].url === null) {
        document
          .getElementById('svgBoard')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            this.current.template.url +
            "')no-repeat 0% 0%;background-size:cover;"
          )
        document
          .getElementById('screen')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            this.current.template.url +
            "')no-repeat 0% 0%;background-size:cover;"
          )
        // bg de la feuille
      } else if (
        sheet_en_cours[0].url !== null &&
        sheet_en_cours[0].url !== ''
      ) {
        document
          .getElementById('svgBoard')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            sheet_en_cours[0].url +
            "')no-repeat 0% 0%;background-size:cover;"
          )
        document
          .getElementById('screen')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            sheet_en_cours[0].url +
            "')no-repeat 0% 0%;background-size:cover;"
          )
        // bg by default
      } else {
        document
          .getElementById('svgBoard')
          .setAttribute(
            'style',
            'background: url("/static/quadrillage.png") repeat scroll 0% 0%'
          )
        document
          .getElementById('screen')
          .setAttribute(
            'style',
            'background: url("/static/quadrillage.png") repeat scroll 0% 0%'
          )
      }
    },
    changeColor (color) {
      this.lineColor = color
      this.$parent.lineColor = color
    },
    linkWithHierarchy () {
      if (this.menu.linkHier) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'linkHier')
      }

      this.lockScreen()
    },
    linkWithoutHierarchy () {
      if (this.menu.linkSimple) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'linkSimple')
      }

      this.lockScreen()
    },
    writingOnOffClick () {
      if (this.menu.modeWriting) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'modeWriting')
      }
      setTimeout(() => {
        this.lockScreen()
      }, 200)
    },
    arrowOnOffClick () {
      if (this.menu.linking) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'linking')
      }
      setTimeout(() => {
        this.lockScreen()
      }, 200)
    },
    erasingOnOffClick () {
      if (this.menu.erasing) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'erasing')
      }
      setTimeout(() => {
        this.lockScreen()
      }, 200)
    },
    drawingOnOffClick () {
      if (this.menu.drawing) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'drawing')
      }
      setTimeout(() => {
        this.lockScreen()
      }, 200)
    },
    selectingOnOffClick () {
      if (this.menu.selecting) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'selecting')
      }
      setTimeout(() => {
        this.lockScreen()
      }, 200)
    },
    // Function called when the user presses enter while the writingbox is active.
    validateText (e) {
      // Get the content of the writingbox, ths position and the width/color from the settings.
      let text = document.querySelector('#textContent')
      let position = {
        x: parseInt(e.target.parentNode.style.left),
        y: parseInt(e.target.parentNode.style.top) + this.width * 2
      }
      text = text.value

      let width = this.width
      let color = this.lineColor
      // Format data for DB storage
      let svgpath = {
        attributs: {
          text: text,
          position: position,
          width: width,
          color: color
        }
      }
      let pathTxt = {
        svgpath: svgpath,
        attributes: svgpath.attributs,
        sheet: this.currentSheet,
        name: 'text' + this.currentSheet
      }
      // If there is text, send it to the DB and reset everything
      if (text !== null && text !== undefined && text !== '') {
        this.sendAsShape(pathTxt)
      }
      document.querySelector('#textContent').value = null
      this.menu.textWriting = false
    },
    // Function called when the board, a drawn svg or text is left-clicked
    clickHandler (e) {
      this.$parent.filterColor(null)
      if (this.$refs.post && this.$refs.post.length > 0) {
        this.$refs.post.forEach(post => {
          post.filteredFromLinks = false
          post.isMenuOpen = false
        })
      }
      if (this.$refs.link && this.$refs.link.length > 0) {
        this.$refs.link.forEach(link => {
          link.editing = false
        })
      }
      // Check for autorisation
      // eslint-disable-next-line no-unused-expressions
      this.width > 50 ? this.width = 50 : null

      if (
        this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer'
      ) {
        // Redirect depending on the setting
        if (this.menu.erasing) {
          this.clean(e)
        }
        if (this.menu.modeWriting) {
          this.openWritingPopup(e)
        }
      }
    },
    // Function called when user clicks the board while in modeWriting
    openWritingPopup (e) {
      // Check for autorisation
      if (
        this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer'
      ) {
        // Activates textWriting, thus showing the writingbox
        this.menu.textWriting = true
        let rect = this.board.getBoundingClientRect()

        let container = document.querySelector('#textWriting')
        // Get the position in X and Y of the click
        let cursorX =
          Math.round(e.clientX - rect.x) ||
          Math.round(e.changedTouches[0].clientX - rect.x)
        let cursorY =
          Math.round(e.clientY - rect.y) ||
          Math.round(e.changedTouches[0].clientY - rect.y)
        // Move writing box to said posiitons
        container.style = `
        border : 2px grey dashed;
        position: absolute;
        top: ${cursorY}px;
        left:${cursorX}px;
        background:none;
        min-width:50px;
        min-height:35px;
        width:max-content;
        height:max-content;
        overflow:visible;
        padding:0px;
        margin:0px;
      `
        // Force focus on the writingBox and empty it
        document.querySelector('#textContent').focus()
        document.querySelector('#textContent').value = null
      }
    },
    openMenu () {
      // Check for autorization
      if (
        this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer'
      ) {
        let e = event
        let rect = this.board.getBoundingClientRect()
        // Get position in X and Y of the click/touch
        let cursorX =
          Math.round(e.clientX - rect.x) ||
          Math.round(e.changedTouches[0].clientX - rect.x)
        let cursorY =
          Math.round(e.clientY - rect.y) ||
          Math.round(e.changedTouches[0].clientY - rect.y)
        let menu = document.querySelector('#drawingMenu')
        // Move the settings menu to the said positions
        menu.style.left = cursorX + 'px'
        menu.style.top = cursorY + 'px'
        // Switch display of the settings menu on right-click
        this.menu.rightClicked = !this.menu.rightClicked
      }
    },
    doubleClickBoard (mouseEvent) {
      if (this.$parent.$refs.zoomButtons.zoomLevel < 1) { // Si l'user a zoomé sur le board
        this.$buefy.dialog.confirm({
          title: this.$i18n.t('dialog.zoomWarningTitle'),
          message: this.$i18n.t('dialog.zoomWarning'),
          cancelText: this.$i18n.t('dialog.cancel'),
          confirmText: this.$i18n.t('dialog.zoomWarningConfirm'),
          type: 'is-success',
          onConfirm: () => {
            this.$parent.$refs.zoomButtons.zoomReset()

          }
        })
      } else {
        this.$store.commit('board/NEW_POST_DEFINE_COORDS', {
          coord_x:
            mouseEvent.clientX -
            document.getElementById('svgBoard').getBoundingClientRect().left,
          coord_y:
            mouseEvent.clientY -
            document.getElementById('svgBoard').getBoundingClientRect().top
        })
        this.$store.commit('board/NEW_POST_POPUP_STATE', true)
        setTimeout(() => {
          this.$parent.$refs.addPostButton.$refs.postContenu.$refs.textarea.focus()
        }, 5)
      }
    },
    // Initiate the Board global object, and other small variables
    initBoard () {
      this.board = document.getElementById('svgBoard')
      this.cursor = $('#cursor')
      this.gesture = false
    },
    // Function called when user presses the mouse down on the board
    linestart (e = event) {
      // Hide the setting menu
      this.menu.rightClicked = false
      this.width > 50 ? this.width = 50 : this.width = this.width
      // Check for autorisations
      if (
        this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer'
      ) {
        // Check if the settings mode is to drawing
        if (this.menu.drawing && e.target.tagName !== 'I' && e.target.tagName !== 'IMG' && e.target.tagName !== 'DIV') {
          let rect = this.board.getBoundingClientRect()
          let cursorX =
            Math.round(e.clientX - rect.x) - 2.2 ||
            Math.round(e.changedTouches[0].clientX - rect.x) - 2.2
          let cursorY =
            Math.round(e.clientY - rect.y) + 13 ||
            Math.round(e.changedTouches[0].clientY - rect.y) + 13
          this.line += 'M' + cursorX + ',' + cursorY
          this.cursor.style.opacity = 1
          this.gesture = true
        } else if (this.menu.selecting && e) {
          let rect = this.board.getBoundingClientRect()
          let cursorX = Math.round(e.clientX - rect.x) || Math.round(e.changedTouches[0].clientX - rect.x)
          let cursorY = Math.round(e.clientY - rect.y) || Math.round(e.changedTouches[0].clientY - rect.y)

          this.selectBox.pressStartPoint.x = this.selectBox.pressStopPoint.x = cursorX
          this.selectBox.pressStartPoint.y = this.selectBox.pressStopPoint.y = cursorY
        }
      }
      // Prevents the screen from moving around on mobile, if needed
      if (e) {
        e.preventDefault()
      }
    },
    // Function called when the user moves the mouse around the board, or when the user moves his finger across the screen on mobile
    lineMove (e = event) {
      // this.lockScreen(e)
      if (this.menu.drawing) {
        // Get the position X and  Y of the event
        let rect = this.board.getBoundingClientRect()
        let cursorX =
          Math.round(e.clientX - rect.x) - 2.2 ||
          Math.round(e.changedTouches[0].clientX - rect.x) - 2.2
        let cursorY =
          Math.round(e.clientY - rect.y) + 13 ||
          Math.round(e.changedTouches[0].clientY - rect.y) + 13
        // Check that the mouse if down
        if (this.gesture == true) {
          this.trace(cursorX, cursorY)
          // Adds a segment to the current line being drawn
          this.line += 'L' + cursorX + ',' + cursorY
        }
        if (e.type === 'touchmove') {
          this.debounced(e)
        }
        this.cursor.style.top = e.clientY - rect.y - this.radius + 'px'
        this.cursor.style.left = e.clientX - rect.x - this.radius + 'px'
        this.cursorX = e.clientX - rect.x
        this.cursorY = e.clientY - rect.y
        this.onCanvas = true
      } else if (this.menu.selecting && this.selecting) {
        let rect = this.board.getBoundingClientRect()
        let cursorX = Math.round(e.clientX - rect.x) || Math.round(e.changedTouches[0].clientX - rect.x)
        let cursorY = Math.round(e.clientY - rect.y) || Math.round(e.changedTouches[0].clientY - rect.y)

        this.selectBox.pressStopPoint.x = cursorX
        this.selectBox.pressStopPoint.y = cursorY

        if (e.type === 'touchmove') {
          this.debounced(e)
        }
      }
    },
    // Function called while drawing, creates small dots lingering being the drawing
    trace (x, y) {
      // Create a div and style it
      let dot = document.createElement('div')
      dot.classList.add('dot')
      dot.style.position = 'absolute'
      dot.style.borderRadius = '5px'
      dot.style.top = y + 'px'
      dot.style.left = x + 'px'
      dot.style.background = this.lineColor
      dot.style.opacity = 0.6
      dot.style.width = dot.style.height = this.radius * 2 + 'px'

      // Select the  dot and delete it after 0.55 seconds
      document.querySelector('#mySpan').appendChild(dot)
      setTimeout(function () {
        dot.style.opacity = 0
      }, 545)
      setTimeout(function () {
        document.querySelector('#mySpan').removeChild(dot)
      }, 550)
    },
    // Function called when the user releases the mouse up, or when the users stops touching the screen on mobile
    lineEnd (e = event) {
      // Check for autorizations

      if (
        this.$store.state.board.current.mode === 'libre' ||
        this.$router.currentRoute.name === 'animer'
      ) {
        // Make sure we are in drawing mode
        if (this.menu.drawing) {
          //   // Get the last position registrered
          //   let cursorX =
          //     this.line
          //       .split('L')
          //       .slice(-1)[0]
          //       .split(',')[0] || this.line.substr(1).split(',')[0]
          //   let cursorY =
          //     this.line
          //       .split('L')
          //       .slice(-1)[0]
          //       .split(',')[1] || this.line.substr(1).split(',')[1]

          //   this.line += 'L' + cursorX + ',' + cursorY

          this.cursor.style.opacity = 0.5
          // Create a new svg with all the segments registered, with the current color and width selected
          let path = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'path'
          )
          path.attributs = {}
          path.attributs.d = this.line
          path.attributs.fill = this.lineColor
          path.attributs.classList = 'drawnPath'
          path.attributs.strokelinecap = 'round'
          path.attributs.strokelinejoin = 'round'

          path.attributs.stroke = this.lineColor
          path.attributs.strokewidth = this.width
          // Adds the delete event on it
          path.addEventListener('click', this.clean)
          // Format the data for the DB
          let pathObj = {
            svgpath: path,
            attributes: path.attributs,
            sheet: this.currentSheet,
            name: 'drawing' + this.currentSheet
          }
          // if the line is longer than one segment, send it to DB
          if (path.attributs.d.indexOf('M') > -1 && path.attributs.d.indexOf('L') > -1) {
            this.sendAsShape(pathObj)
          }
          // Reset everything
          this.gesture = false
          this.line = ''
        } else {
          if (this.menu.selecting && (e.target.id === 'selectBox' || e.target.id === 'svgBoard')) {
            this.selecting = false

            let rect = this.board.getBoundingClientRect()
            let cursorX = Math.round(e.clientX - rect.x) || Math.round(e.changedTouches[0].clientX - rect.x)
            let cursorY = Math.round(e.clientY - rect.y) || Math.round(e.changedTouches[0].clientY - rect.y)
            let svgSelectBox = document.querySelector('#selectBox')

            this.selectBox.pressStopPoint.x = cursorX
            this.selectBox.pressStopPoint.y = cursorY

            let svgSelectX = parseInt(svgSelectBox.attributes.x.value)
            let svgSelectY = parseInt(svgSelectBox.attributes.y.value)
            let svgSelectWidth = parseInt(svgSelectBox.attributes.width.value)
            let svgSelectHeight = parseInt(svgSelectBox.attributes.height.value)

            this.selectedPosts = []

            for (let i = 0; i < this.postlist.length; i++) {
              let post = this.postlist[i]

              if (
                (
                  (post.coord_x > svgSelectX) &&
                  ((post.coord_x + 250) < (svgSelectX + svgSelectWidth))
                ) && (
                  (post.coord_y > svgSelectY) &&
                  ((post.coord_y + 60) < (svgSelectY + svgSelectHeight))
                ) && (
                  post.sheet_id === this.currentSheet
                ) &&
                (
                  post.couleur === this.hasFilteredColor || this.hasFilteredColor === null
                ) &&
                (post.folder_id === null || post.folder_id === undefined)
              ) {
                if (document.querySelector('#postitnumber' + post.id).attributes.opacity.value === '1') {
                  this.selectOnePost(post.id)
                }
              }
            }
            if (this.selectedPosts.length > 0) {
              this.$store.commit('board/ETAT_MENU', '')
              this.lockScreen()
            }
          }
        }
      }
    },
    // Turn rgb color codes to hexadecimals
    rgb2hex (rgb) {
      if (rgb.search('rgb') == -1) {
        return rgb
      } else {
        rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/)
        function hex (x) {
          return ('0' + parseInt(x).toString(16)).slice(-2)
        }
        return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3])
      }
    },
    setActiveColor (Li) {
      let allColors = $$(Li)
      let target = event.target // for set time out
      for (let color of allColors) {
        color.classList.remove('activeColor')
      }
      setTimeout(function () {
        target.classList.add('activeColor')
      }, 10)
    },
    setActiveColorMounted (li, arr, color) {
      let allLi = $$(li)
      let colorIndex = arr.indexOf(color)
      for (let li of allLi) {
        let liColor = this.rgb2hex(li.style.backgroundColor).toUpperCase()
        if (liColor === color) {
          li.classList.add('activeColor')
          this.arrayMove(arr, colorIndex, 0)
        }
      }
    },
    // Sends a given shape to the DB
    async modifyShape (shape) {

    },
    async sendAsShape (shape) {
      const res = await fetch(
        `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            urlparticipant: this.current.url_participant
          },
          body: JSON.stringify(shape)
        }
      )
    },
    // Delete shapes
    async clean (e) {
      // Check for autorizations
      if (
        this.menu.erasing &&
        e.target.id !== 'svgBoard' &&
        e.target.attributes.opacity.value === '1'
      ) {
        // Sends the delete action to the backend
        let res = await fetch(
          `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape/${e.target.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              urlparticipant: this.current.url_participant
            }
          }
        )
      }
    },
    // Function called after mount, gets the shapes from the DB
    async getShapes (uglyInterval) {
      // Check if we have the url from the store
      if (this.current.url_participant !== undefined) {
        // if we do, stops the interval, fetch the shapes and push them to their objects
        clearInterval(uglyInterval)

        // GET SHAPES
        let res = await fetch(
          `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/shape`,
          {
            headers: {
              'Content-Type': 'application/json',
              urlparticipant: this.current.url_participant
            }
          }
        )
        let body = await res.json()
        // Sort the text and the drawn svg's
        body.forEach(path => {
          path.attributes = JSON.parse(path.svgpath).attributs
          if (Object.keys(path.attributes).includes('text')) {
            this.texts.push(path)
          } else {
            this.drawnSVG.push(path)
          }
        })

        // GET LINKS
        res = await fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/link`, { // sends them
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
            // 'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
        body = await res.json()
        this.links.push(...body)

        // GET FOLDERS
        res = await fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder`, { // sends them
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
            // 'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
        body = await res.json()
        this.$store.commit('board/LOAD_FOLDER', body)
      }
    },
    // Function called when drawing mode is selected to lock the screen on mobile
    lockScreen (e) {
      let board = document.querySelector('#svgBoard')
      if (this.menu.drawing || this.menu.selecting) {
        this.lockDebouncing(e)
        board.addEventListener('touchstart', this.linestart, {
          passive: false
        })
      } else {
        board.removeEventListener('touchstart', this.linestart, {
          passive: false
        })
      }
      // if (this.menu.drawing || this.menu.modeArrow || this.menu.selecting) {
      //   console.log('lock ')

      //   board.addEventListener('touchmove', this.lineMove, {
      //     passive: false
      //   })
      // } else {
      //   console.log('unlock ')
      //   board.removeEventListener('touchmove', this.lineMove, {
      //     passive: false
      //   })
      // }
    }
  },
  mounted () {
    // Initialize the board
    this.initBoard()

    let uglyInterval = setInterval(() => {
      this.getShapes(uglyInterval)
      var room = 'Room_Brain_' + this.current.id
      this.$socket.emit('room', room)
    }, 200)
  },
  beforeDestroy () {
    EventBus.$off('UPLOAD_SHEET')
  },
  sockets: {
    connect () {
      this.$store.commit('board/SOCKET_STATE', { state: true })
      var room = 'Room_Brain_' + this.current.id
      this.$socket.emit('room', room)
    },
    disconnect () {
      this.$store.commit('board/SOCKET_STATE', { state: false })
    },
    async channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
      // console.log(decodeddata)
      if (decodeddata.type === 'UPDATE_LINK') {
        let link = decodeddata.post
        this.links = this.links.filter((localLink) => {
          return (localLink.id !== link.id)
        })
        this.links.push(link)
      }
      if (decodeddata.type === 'CREATE_LINK') {
        let link = decodeddata.post
        this.links.push(link)
        let postsToUpdate = this.$refs.post.filter(post => post.id === link.parent_post || link.child_post === post.id)
        if (postsToUpdate && postsToUpdate.length > 0 && !postsToUpdate.some(post => post.etat !== 'publie')) {
          // console.log(postsToUpdate)
          postsToUpdate.forEach(post => {
            post.isLinked = true
          })
        }
      }
      if (decodeddata.type === 'DESTROY_LINK') {
        // console.log(decodeddata, this.links)

        this.links = await this.links.filter(link => link.id !== decodeddata.post)
        setTimeout(() => {
          if (this.$refs && this.$refs.post && this.$refs.post.length > 0) {
            this.$refs.post.forEach(post => {
              // console.log('checklinked')
              post.checkIsLinked()
            })
          }
        }, 300)
      }
      if (decodeddata.type === 'NEW_SHAPE') {
        let shape = decodeddata.post
        shape.attributes = JSON.parse(shape.svgpath).attributs
        if (Object.keys(shape.attributes).includes('text')) {
          this.texts.push(decodeddata.post)
        } else {
          this.drawnSVG.push(decodeddata.post)
        }
      }
      if (decodeddata.type === 'UPDATE_SHAPE') {
        let post = decodeddata.post
        post.attributes = JSON.parse(post.svgpath).attributs
        this.drawnSVG.forEach((shape, key) => {
          if (shape.id === post.id) {
            this.drawnSVG[key] = post
            this.drawnSVG.reverse()
          }
        })
        this.texts.forEach((shape, key) => {
          if (shape.id === post.id) {
            this.texts[key] = post
            this.texts.reverse()
          }
        })
      }
      if (decodeddata.type === 'DESTROY_SHAPE') {
        this.drawnSVG = this.drawnSVG.filter(shape => {
          return shape.id !== decodeddata.post.id
        })
        this.texts = this.texts.filter(shape => {
          return shape.id !== decodeddata.post.id
        })
      }

      if (decodeddata.type === 'CREATE_FOLDER') {
        let payload = decodeddata.post.new_folder
        payload.posts = decodeddata.post.posts
        this.folders.push(payload)
      }
      if (decodeddata.type === 'UPDATE_FOLDER') {
        let folder = decodeddata.post

        let payload = folder['folder_update']
        payload.posts = folder['posts']
        // console.log(payload)
        this.$store.commit('board/UPDATE_FOLDER', payload)
      }
      if (decodeddata.type === 'DESTROY_FOLDER') {
        this.$store.commit('board/DELETE_FOLDER', decodeddata.post.id)
      }
    }
  }
}
</script>
<style scoped>
#mySpan {
  display: block;
  position: absolute;
  width: max-content;
  height: max-content;
  transform-origin: top left;
  /* touch-action: none; */
  user-select: none;
}

#clickBlocker {
  position: absolute;
  width: 3840px;
  height: 2160px;
  background: #fff0;
}

#colorSelect {
  width: 100%;
  text-align: left;
  margin: 10px;
}
#sheetSelect {
  width: 100%;
  text-align: left;
  margin: 10px;
}
#groupEditColorCont {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-content: center;
  padding: 0px 95px;
  margin-bottom: 15px;
}

.selected {
  border: 3px solid black;
}
.colorPicker {
  width: 40px;
  height: 40px;
  margin: 5px 5px;
  border-radius: 50%;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.colorCircle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

#bodyModalCont {
  padding: 20px;
  background-color: white;
  border-radius: 5px;
}

#selectMenu > span {
  margin: 0px 2px;
  cursor: pointer;
}
#selectMenu {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 60px;
  flex-flow: row nowrap;
  height: 25px;
  justify-content: end;
  padding: 0px 2px;
}
.editbutton {
  color: white;
}
.folderize {
  color: white;
}

#selectBox {
  background-color: #3535c78a;
}

#drawingArrowHead {
  filter: invert(100%);
}

.slider {
  background: #424a60;
}
input[type="range"] {
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #ffffff;
  background: #424a60;
  border-radius: 5px;
  border: 1px solid #ffffff;
}
input[type="range"]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #000000;
  border: 1px solid #000000;
  height: 18px;
  width: 8px;
  border-radius: 5px;
  background: #ffffff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -5px;
}
input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #424a60;
}
input[type="range"]::-moz-range-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #ffffff;
  background: #424a60;
  border-radius: 5px;
  border: 1px solid #ffffff;
}
input[type="range"]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000000;
  border: 1px solid #000000;
  height: 18px;
  width: 8px;
  border-radius: 5px;
  background: #ffffff;
  cursor: pointer;
}
input[type="range"]::-ms-track {
  width: 100%;
  height: 10px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type="range"]::-ms-fill-lower {
  background: #424a60;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 1px #ffffff;
}
input[type="range"]::-ms-fill-upper {
  background: #424a60;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 1px #ffffff;
}
input[type="range"]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 1px 1px 1px #000000;
  border: 1px solid #000000;
  height: 18px;
  width: 8px;
  border-radius: 5px;
  background: #ffffff;
  cursor: pointer;
}
input[type="range"]:focus::-ms-fill-lower {
  background: #424a60;
}
input[type="range"]:focus::-ms-fill-upper {
  background: #424a60;
}

#textContent {
  width: 100%;
  height: 100%;
  background: none;
  background: #ffffff66;
  border: none;
  padding: 0px;
  margin: 0px;
}

path {
  fill: none;
}
#drawingWidth {
  display: flex;
  justify-content: space-evenly;
}
#drawingColors {
  display: flex;
  flex-flow: row wrap;
}
.colorBlock {
  border: 1px solid white;
  margin: 2px;
  width: 20px;
  height: 20px;
}
.drawingMenuBlock:not(:first-of-type) {
  border-top: white solid 1px;
}

#drawingMenu {
  position: absolute;
  min-width: 150px;
  max-width: 350px;
  display: flex;
  padding: 5px;
  margin: 5px;
  z-index: 10;
  background-color: #424a60;
  color: white;
  border: darkgrey 1px solid;
  border-radius: 5px;
  flex-flow: column nowrap;
}

.overlay {
  opacity: 0.5;
}
#svgBoard {
  height: 2160px !important;
  width: 3840px !important;
  margin: auto;
  font-family: "Helvetica", "Arial", sans-serif;
  opacity: 1;
}
.type {
  fill: #888;
  text-anchor: middle;
}

#test {
  fill: none;
  stroke: black;
  stroke-width: 2px;
}
.shape {
  fill: #eee;
  stroke: #ccc;
}

.dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  position: absolute !important;
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 0.1s ease-in-out;
}
.eraseCursor {
  cursor: url("/static/Eraser-icon.png") 1 20, default;
}
.drawCursor {
  cursor: url("/static/pencil-cursor.png"), default;
}
.writingCursor {
  cursor: url("/static/formatText.png"), text;
}
.defaultCursor {
  cursor: default;
}

#drawingOptions {
  margin-bottom: 0px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}
#drawingOnOff,
#erasingOnOff,
#writingOnOff,
#selectingOnOff,
#arrowOnOff {
  padding: 4px;
  border-radius: 3px;
  cursor: pointer;
  display: inline;
}
.active {
  padding: 3px !important;

  box-shadow: inset 0px 0px 7px #000;
  outline: none;
  border: 1px solid #2a4868;
  border-radius: 3px;
  cursor: pointer;
}

.b-tooltip::after {
  font-size: 0.75rem;
  padding: 0.25rem 0.65rem;
}
</style>



// WEBPACK FOOTER //
// src/components/board/board.vue